<template>
  <div class="animated fadeIn">
    <!-- Filter Branch (satu untuk semua section dashboard)yes -->
    <div class="row mb-20" v-if="showBranchFilter">
      <div class="col-12">
        <div class="box-mini">
          <div class="row p-15 align-items-center">
            <div class="col-auto col-form-label text-right">
              <label class="mb-0 font-bold">Branch</label>
            </div>
            <div class="col-sm-3">
              <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
              </b-form-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-20">
      <div class="col-md-4">
        <!-- {{dataNB}} -->
        <div class="font-bold mb-10">Monthly Calendar</div>
        <div class="nav-tabs-boxed nav-tabs-boxed-left">
          <b-tabs content-class="mt-3">
            <b-tab title="Calendar" active>
              <div class="p-10">
                <template
                  v-if="parseInt(role) == 3 || parseInt(role) === 4 || parseInt(role) === 6 || parseInt(role) === 8 || parseInt(role) === 17 || parseInt(role) === 18 || parseInt(role) === 22 || parseInt(role) === 20">
                  <vc-calendar :attributes="attrs" @dayclick="getSelectedDate" @update:to-page="getSelectedPage" />
                </template>
                <template v-else>
                  <calendar :begin="calendar1.begin" :end="calendar1.end" :events="calendar1.events"
                    :lunar="calendar1.lunar" :months="calendar1.months" :value="calendar1.value"
                    :weeks="calendar1.weeks" @select="calendar1.select"></calendar>
                </template>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
      <template
        v-if="parseInt(role) == 3 || parseInt(role) === 4 || parseInt(role) === 6 || parseInt(role) === 8 || parseInt(role) === 17 || parseInt(role) === 18 || parseInt(role) === 22 || parseInt(role) === 20">
        <!--        <div class="col-md-6">-->
        <!--        <div class="font-bold mb-10">-->
        <!--          <div class="row justify-content-between">-->
        <!--            <div class="col-md-3 line-25">-->
        <!--              Activity Calendar-->
        <!--            </div>-->
        <!--            <div class="col-md-3">-->
        <!--              <flat-pickr @on-change="changeRangeDate" :config="exportConfig" class="font-13" v-model="exportDates" name="export_date_start"></flat-pickr>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="box-mini">-->
        <!--          <div class="p-15 box-group">-->
        <!--            <div class="activity-group">-->
        <!--              <table class="table table-borderless" v-for="(data, index) in dailyItemsLeads" :key="index">-->
        <!--                <tbody>-->
        <!--                <tr align="center">-->
        <!--                  <td colspan="4" class="clock">{{data.start_time}}</td>-->
        <!--                </tr>-->
        <!--                <tr class="content">-->
        <!--                  <td align="center">{{data.leads_activities_type.name}}</td>-->
        <!--                  <td align="center">{{data.leads_activities_status.name}}</td>-->
        <!--                  <td align="center" class="activity-instructure">{{data.lead.first_name}} {{data.lead.last_name}}</span></td>-->
        <!--                  <td align="center"><button class="btn btn-table warning btn-secondary" @click="openPage('/leads/detail?id=' + data.leads_id)">Details</button></td>-->
        <!--                </tr>-->
        <!--                <tr align="center">-->
        <!--                  <td colspan="4">By {{data.sales_owner.fullname}}</td>-->
        <!--                </tr>-->
        <!--                </tbody>-->
        <!--              </table>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--        <div class="col-md-6">-->
        <!--          <div class="font-bold mb-10 line-25">Idle Member</div>-->
        <!--          <div class="box-mini">-->
        <!--            <div class="p-15 box-group">-->
        <!--              <b-table :items="itemsIdles" :fields="fields_idle" striped responsive="sm">-->
        <!--                <template v-slot:cell(no)="data">-->
        <!--                  {{ data.index + 1 }}-->
        <!--                </template>-->
        <!--                <template v-slot:cell(name)="data">-->
        <!--                  {{data.item.first_name}} {{data.item.last_name}}-->
        <!--                </template>-->
        <!--                <template v-slot:cell(actions)="data">-->
        <!--                  <b-button size="sm" @click="openPage('/memberData/detail?id=' + data.item.id)" class="btn btn-table warning btn-secondary mr-2">-->
        <!--                    Details-->
        <!--                  </b-button>-->
        <!--                </template>-->
        <!--              </b-table>-->
        <!--              <app-pagination :current-page="currentPageIdle" :total-pages="totalPageIdle"-->
        <!--                              @page-changed="pageOneIdleChanged"-->
        <!--                              class="pagination-custom mt-20"-->
        <!--                              next-text="Next" prev-text="Prev"/>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!-- <div class="col-md-8">
          <div class="font-bold mb-10">Activity Calendar</div>
          <div class="box-mini">
            <div class="p-10 box-group">
              <div class="activity-group">
                <template v-if="dailyItemsLeads.length > 0">
                  <table class="table table-borderless" v-for="(data, index) in dailyItemsLeads" :key="index">
                    <tbody>
                    <tr align="center">
                      <td colspan="4" class="clock">{{data.start_time}}</td>
                    </tr>
                    <tr class="content">
                      <td align="center">{{data.leads_activities_type.name}}</td>
                      <td align="center">{{data.leads_activities_status.name}}</td>
                      <td align="center" class="activity-instructure">{{data.lead.first_name}} {{data.lead.last_name}}</td>
                      <td align="center" style="width:100px;"><button class="btn btn-table warning btn-secondary" @click="openPage('/leads/detail?id=' + data.leads_id)">Details</button></td>
                    </tr>
                    <tr align="center">
                      <td colspan="4">By {{data.sales_owner.fullname}}</td>
                    </tr>
                    </tbody>
                  </table>
                </template>
                <template v-else>
                  <div class="text-center">No data present</div>
                </template>
              </div>
            </div>
          </div>
        </div> -->
        <div class="col-md-8">
          <div class="font-bold mb-10">Activity Calendar</div>
          <div class="nav-tabs-boxed nav-tabs-boxed-left">
            <b-tabs content-class="mt-3">
              <b-tab title="Sales Activity" active>
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col-sm-3 col-form-label text-right">
                      Activity Type
                    </div>
                    <div class="col-sm-4">
                      <b-form-select name="branch" v-model="leads_activities_type_id" @change="changeActivity">
                        <option :value="null">Please select</option>
                        <option v-for="item in leads_activities_type" :key="item.id" :value="item.id">{{ item.name }}
                        </option>
                      </b-form-select>
                    </div>
                  </div>

                </div>

                <div class="p-10 box-group">
                  <div class="activity-group">
                    <template v-if="dailyItemsLeads.length > 0">
                      <table class="table table-borderless" v-for="(data, index) in dailyItemsLeads" :key="index">
                        <tbody>
                          <tr align="center">
                            <td colspan="4" class="clock">{{ data.start_time }}</td>
                          </tr>
                          <tr class="content">
                            <td align="center">{{ data.leads_activities_type.name }}</td>
                            <td align="center">{{ data.leads_activities_status.name }}</td>
                            <td align="center" class="activity-instructure">{{ data.lead.first_name }}
                              {{ data.lead.last_name }}</td>
                            <td align="center" style="width:100px;"><button class="btn btn-table warning btn-secondary"
                                @click="openPage('/leads/detail?id=' + data.leads_id)">Details</button></td>
                          </tr>
                          <tr align="center">
                            <td colspan="4">By {{ data.sales_owner.fullname }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                    <template v-else>
                      <div class="text-center">No data present</div>
                    </template>
                  </div>
                </div>
              </b-tab>

              <!-- dailyItemsPersonal_trainer -->
              <b-tab title="PT Activity" v-if="role != 4">
                <div class="p-10 box-group">
                  <div class="activity-group">
                    <template v-if="dailyItemsPersonal_trainer.length > 0">
                      <table class="table table-borderless" v-for="(data, index) in dailyItemsPersonal_trainer"
                        :key="index">
                        <tbody>
                          <tr align="center">
                            <td colspan="4" class="clock">{{ data.pt_planner_time.time_start }}</td>
                          </tr>
                          <tr class="content">
                            <!-- <td align="center">{{data.leads_activities_type.name}}</td> -->
                            <td align="center">{{ data.pt_planner_activity.pt_planner_activity }}</td>
                            <td align="center" class="activity-instructure">{{ data.member.member_name }}</td>
                            <td align="center" style="width:100px;"><button class="btn btn-table warning btn-secondary"
                                @click="openPage('/leads/detail?id=' + data.leads_id)">Details</button></td>
                          </tr>
                          <tr align="center">
                            <td colspan="4">By {{ data.personal_training.personal_trainer }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                    <template v-else>
                      <div class="text-center">No data present</div>
                    </template>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="col-md-8">
          <div class="font-bold mb-10">Weekly Calendar</div>
          <div class="box-mini">
            <div class="p-15 pl-0 pr-0 pb-0">
              <div class="text-center mb-15">
                <div class="font-16 font-500">{{ parseDateTime3() }}</div>
              </div>
              <div class="overflow-x">
                <table class="table-week w-100">
                  <thead>
                    <tr>
                      <th :key="dateDay.id" class="weekDate text-center" v-for="dateDay in checkDateToday">
                        <div :class="{ 'active-today': todayNumber() === getNumberDay(dateDay) }"
                          class="title-table-container">
                          <div class="title">{{ parseDateTime1(dateDay) }}</div>
                          <div class="sub">{{ parseDateTime2(dateDay) }}</div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="main-body">
                      <td :key="dateDayBody.id" class="main-body" v-for="dateDayBody in checkDateToday">
                        <template v-for="(itemData, index) in itemsLeads">
                          <a :class="{ 'current': todayNumber() === getNumberDay(itemData.due_date), 'btn-disabled': currentRoleId == '6' }"
                            :key="index + 'list'" @click="detailActivity('/leads/detail?id=' + itemData.leads_id)"
                            class="table-schedule on"
                            v-if="getTodayDate(itemData.due_date) === getTodayDate(dateDayBody)">
                            <div class="part1">{{ cutTime(itemData.start_time) }}<i class="fas fa-pen"></i></div>
                            <div class="part2 font-500">{{ itemData.leads_activities_type.name }}</div>
                            <div>[{{ itemData.leads_activities_status == null ? "-" :
                              itemData.leads_activities_status.name }}]
                            </div>
                            <template v-if="itemData.lead">
                              <div class="part3">With <strong>{{ itemData.lead.first_name }}
                                  {{ itemData.lead.last_name }}</strong></div>
                              <span>by {{ itemData.sales_owner.fullname }}</span>
                            </template>
                          </a>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- Member Not Check-In 2week -->
    <div class="row mb-20"
      v-if="parseInt(role) == 3 || parseInt(role) === 4 || parseInt(role) === 17 || parseInt(role) === 20 || parseInt(role) === 35 || parseInt(role) === 34">
      <div class="col-md-12">
        <div class="font-bold mb-10">Member Not Check-In 2week</div>
        <div class="box-mini">
          <div class="row mt-3">
            <table>
              <tr>
                <td>
                  <div class="col-auto col-form-label text-right">
                    <label style="padding-right: 20%;margin:0">Advisor</label>
                  </div>
                </td>
                <td>
                  <b-form-select name="branch" v-model="selectedSalesIdNotCheckIn2Weeks"
                    @change="notCheckIn2WeeksSalesChanged">
                    <option :value="''">Select Sales</option>
                    <option v-for="item in listSalesMemberNotCheckIn2Weeks" :key="item.id" :value="item.id">{{ item.name
                    }}
                    </option>
                  </b-form-select>
                </td>
                <td>
                  <!-- button -->
                  <b-button style="margin-left: 5px;" size="sm" @click="exportReportNotCheckInTwoWeek()"
                    class="btn btn-table warning btn-secondary ms-5">
                    Export
                  </b-button>
                </td>

              </tr>
            </table>
          </div>
          <div class="p-15">
            <b-table :busy="isLoadingNotCheckInTwoWeeks" :items="itemMemberNotCheckIn2Weeks" :fields="fields_idle"
              striped :responsive="true">
              <template v-slot:cell(no)="data">
                {{ data.index + 1 }}
              </template>
              <template v-slot:cell(name)="data">
                {{ data.item.first_name }} {{ data.item.last_name }}
              </template>
              <template v-slot:cell(advisor)="data">
                {{ data.item.sales ? data.item.sales.fullname : '-' }}
              </template>
              <!-- last_gym_attendance -->
              <template v-slot:cell(last_gym_attendance)="data">
                <span>{{ data.item.last_attendance == null ? '-' : data.item.last_attendance }}</span>
              </template>
              <template v-slot:cell(last_activity_at)="data">
                <span>{{ data.item.last_activity_at == null ? '-' : data.item.last_activity_at }}</span>
              </template>
              <template v-slot:cell(last_activity_by)="data">
                <span>{{ data.item.last_activity_by == null ? '-' : data.item.last_activity_by }}</span>
              </template>
              <template v-slot:cell(actions)="data">
                <b-button size="sm" @click="openPage('/memberData/detail?id=' + data.item.id + '&id_lead=' + data.item.lead.id)"
                  class="btn btn-table warning btn-secondary mr-2">
                  Details
                </b-button>
              </template>
            </b-table>
            <app-pagination :current-page="currentPageNotCheckIn2Weeks" :total-pages="totalPageNotCheckIn2Weeks"
              @page-changed="pageOneNotCheckIn2WeeksChanged" class="pagination-custom mt-20" next-text="Next"
              prev-text="Prev" />
          </div>
        </div>
      </div>
    </div>

    <!-- Member Not Continue -->
    <div class="row mb-20"
      v-if="parseInt(role) == 3 || parseInt(role) === 4 || parseInt(role) === 17 || parseInt(role) === 20 || parseInt(role) === 35 || parseInt(role) === 34">
      <div class="col-md-12">
        <div class="font-bold mb-10">Member Not Continue PT Session</div>
        <div class="box-mini">
          <div class="row mt-3">
            <table>
              <tr>
                <td></td>
                <td>
                  <!-- button -->
                  <b-button style="margin-left: 25px;" size="sm" @click="exportMemberNotContinue()"
                    class="btn btn-table warning btn-secondary ms-5">
                    Export
                  </b-button>
                </td>
              </tr>
            </table>
          </div>
          <div class="p-15">
            <b-table :busy="isLoadingMemberNotContinue" :items="itemMemberNotContinue" :fields="fields_member_not_continue"
              striped :responsive="true">
              <template v-slot:cell(expired_at)="data">
                {{ data.item.expired_at | moment('DD MMMM YYYY') }}
              </template>
            </b-table>
            <app-pagination :current-page="currentPageMemberNotContinue" :total-pages="totalPageMemberNotContinue"
              @page-changed="pageOneMemberNotContinueChanged" class="pagination-custom mt-20" next-text="Next"
              prev-text="Prev" />
          </div>
        </div>
      </div>
    </div>

    <!-- Leads - Empty Activity -->
    <div class="row mb-20"
      v-if="parseInt(role) == 3 || parseInt(role) === 4 || parseInt(role) === 17 || parseInt(role) === 20">
      <div class="col-12">
        <div class="font-bold mb-10">Leads - Empty Activity</div>
        <div class="box-mini">
          <div class="row mt-3">
            <template v-if="parseInt(role) !== 3">
              <div class="col-auto col-form-label text-right">
                <label style="padding-left: 30%;">Sales</label>
              </div>
              <div class="col-sm-3">
                <b-form-select name="sales_empty_activity" v-model="selectedSalesIdEmptyActivity"
                  @change="changeSalesEmptyActivity">
                  <option value="">All Sales</option>
                  <option v-for="item in listSalesEmptyActivity" :key="item.id" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </div>
            </template>

            <div class="col-auto">
              <b-button size="sm" @click="exportEmptyActivity" class="btn btn-table warning btn-secondary mr-2">
                Export
              </b-button>
            </div>
          </div>
          <div class="p-15">
            <b-table :busy="isLoadingEmptyActivity" :bordered="bordered" :fields="role === '3' ? fields_sales : fieldsEmptyActivity" :fixed="fixed"
              :hover="hover" :items="itemsEmptyLeads" :small="small" :striped="striped" @sort-changed="sortingChanged"
              responsive="lg">
              <template v-slot:cell(name)="data">
                {{ data.item.first_name }} {{ data.item.last_name }}
              </template>
              <template v-slot:cell(leads_source_type)="data">
                <span>{{ (data.item.leads_source_type) ? data.item.leads_source_type.name : '-' }}</span>
              </template>
              <template v-slot:cell(sale)="data">
                <span>{{ (data.item.sale) ? data.item.sale.fullname : '-' }}</span>
              </template>
              <template v-slot:cell(actions)="data">
                <b-button @click="editBanner('/slideBanner/edit?id=' + data.item.id)" class="btn-table primary mr-1"
                  size="sm">
                  <i class="far fa-edit"></i> Edit
                </b-button>
                <b-button class="btn-table danger" size="sm" v-on:click="deleteBanner(data.item.id)">
                  <i class="fas fa-times"></i> Delete
                </b-button>
              </template>
              <template v-slot:cell(actions)="data">
                <b-button size="sm" class="btn btn-table warning btn-secondary mr-2"
                  @click="openPage('/leads/detail?id=' + data.item.id)">
                  Details
                </b-button>
              </template>
            </b-table>
            <app-pagination :current-page="currentPageEmptyActivity" :total-pages="totalPageEmptyActivity"
              @page-changed="pageOneChangedEmptyActivity" class="pagination-custom mt-20" next-text="Next"
              prev-text="Prev" />
          </div>
        </div>
      </div>
    </div>
    <!-- Member Join -->
    <div class="row mb-20"
      v-if="parseInt(role) == 3 || parseInt(role) === 4 || parseInt(role) === 17 || parseInt(role) === 20">
      <div class="col-12">
        <div class="font-bold mb-10">Member Join</div>
        <div class="box-mini">
          <div class="p-15 pb-0">
            <div class="row">
              <div class="col-sm-6">
                <table>
                  <tr>
                    <td>
                      <flat-pickr :config="member_join.datesConfig" @on-change="changeDateBooking"
                        v-model="member_join.datesValue" name="export_date_start" class="font-13"></flat-pickr>
                    </td>
                    <td style="width: 190px;" v-if="parseInt(role) !== 3">
                      <div class="col-sm-12">
                        <b-form-select name="sales_member_join" v-model="selectedSalesIdMemberJoin"
                          @change="changeSalesMemberJoin">
                          <option value="">All Sales</option>
                          <option v-for="item in listSalesMemberJoin" :key="item.id" :value="item.id">{{ item.name }}</option>
                        </b-form-select>
                      </div>
                    </td>
                    <td>
                      <div class="col-sm-12">
                        <b-button size="sm" @click="exportMemberJoin" class="btn btn-table warning btn-secondary mr-2">
                          Export
                        </b-button>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="col-sm-2">
              </div>
              <div class="col-sm-4 text-right">
                <!-- <div class="search-header">
                  <div class="custom-search-container">
                    <div class="input-group custom-search">
                      <input type="text" @keyup.enter="needToDoEnterClicked(needToDoSearchData)" v-model="needToDoSearchData" class="form-control" placeholder="Search">
                      <span class="icon-magnifier icon-input-custom"></span>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div class="p-15">
            <b-table :busy="isLoadingMemberJoin" :items="member_join.items" :fields="member_join.table_fields" striped responsive="sm">
              <template v-slot:cell(no)="data">
                {{ data.index + 1 }}
              </template>
              <!-- <template v-slot:cell(name)="data">
                {{data.item.lead == null ? '-'}} {{data.item.lead.last_name}}
              </template> -->
              <!-- <template v-slot:cell(created_at)="data">
                {{data.item.created_at | moment('DD MMMM YYYY')}}
              </template>
              <template v-slot:cell(updated_at)="data">
                {{data.item.updated_at | moment('DD MMMM YYYY')}}
              </template> -->
              <template v-slot:cell(actions)="data">
                <b-button size="sm"
                  @click="detailActivity('/memberData/detail?id=' + data.item.id + '&id_lead=' + data.item.lead.id)"
                  class="btn btn-table warning btn-secondary mr-2">
                  Details
                </b-button>
              </template>
            </b-table>
            <app-pagination :current-page="member_join.currentPage" :total-pages="member_join.totalPage"
              @page-changed="pageOneMemberJoinChanged" class="pagination-custom mt-20" next-text="Next"
              prev-text="Prev" />
          </div>
        </div>
      </div>
    </div>
    <!-- Table Need To Do -->
    <div class="row mb-20"
      v-if="parseInt(role) == 3 || parseInt(role) === 4 || parseInt(role) === 17 || parseInt(role) === 20">
      <div class="col-12">
        <div class="font-bold mb-10">Need To Do (Aktifitas)</div>
        <div class="box-mini">
          <div class="p-15 pb-0">
            <div class="row">
              <div class="col-sm-6">
                <table>
                  <tr>
                    <td>
                      <flat-pickr :config="needTodoDatesConfig" @on-change="changeDateNeedToDo" v-model="needTodoDates"
                        name="export_date_start" class="font-13"></flat-pickr>
                    </td>
                    <td style="width: 190px;" v-if="role != 3 || role != '3'">
                      <div class="col-sm-12">
                        <b-form-select name="branch" v-model="selectedSalesId" @change="needToDoChangeSales">
                          <option :value="''">Select Sales</option>
                          <option v-for="item in listSales" :key="item.id" :value="item.id">{{ item.name }}</option>
                        </b-form-select>
                      </div>
                    </td>
                    <td>
                      <div class="col-sm-12">
                        <!-- btn export -->
                        <b-button size="sm" @click="exportNeedToDo" class="btn btn-table warning btn-secondary mr-2">
                          Export
                        </b-button>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="col-sm-2"></div>
              <div class="col-sm-4 text-right">
                <div class="search-header">
                  <div class="custom-search-container">
                    <div class="input-group custom-search">
                      <input type="text" @keyup.enter="needToDoEnterClicked(needToDoSearchData)"
                        v-model="needToDoSearchData" class="form-control" placeholder="Search">
                      <span class="icon-magnifier icon-input-custom"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-15">
            <b-table :busy="loadingNeedToDo" :items="dailyItemsLeadsNeedToDo" :fields="fields_need_to_do" striped responsive="sm">
              <template v-slot:cell(no)="data">
                {{ data.index + 1 }}
              </template>
              <template v-slot:cell(name)="data">
                {{ data.item.first_name }} {{ data.item.last_name }}
              </template>
              <template v-slot:cell(created_at)="data">
                {{ data.item.created_at | moment('DD MMMM YYYY') }}
              </template>
              <template v-slot:cell(updated_at)="data">
                {{ data.item.updated_at | moment('DD MMMM YYYY') }}
              </template>
              <template v-slot:cell(actions)="data">
                <b-button size="sm" @click="detailActivity('/leads/detail?id=' + data.item.leads_id)"
                  class="btn btn-table warning btn-secondary mr-2">
                  Details
                </b-button>
              </template>
            </b-table>
            <app-pagination :current-page="currentPageNeedToDo" :total-pages="totalPageNeedToDo"
              @page-changed="pageOneNeedToDoChanged" class="pagination-custom mt-20" next-text="Next"
              prev-text="Prev" />
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Callout } from '@coreui/vue'
import Calendar from '@/views/component/calendar'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import Pagination from '@/views/component/pagination'
import Chart from '@/views/component/chart'

export default {
  name: 'dashboard',
  components: {
    'calendar': Calendar,
    'app-pagination': Pagination,
    // 'app-chart': Chart
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loadingActive: false,
      leads_activities_type: [],
      leads_activities_type_id: null,
      fields: [
        {
          key: 'name',
          label: 'Leads Name',
          sortable: true
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true
        },
        {
          key: 'phone_number',
          label: 'Phone',
          sortable: true
        },
        // {
        //     key: 'leads_source_type',
        //     label: 'Lead Source',
        //     sortable: true
        // },
        {
          key: 'sale.fullname',
          label: 'Advisor',
          sortable: true
        },
        {
          key: 'created_at',
          label: 'Lead Created Date',
          sortable: true,
          formatter: value => {
            return moment(value).format('DD MMMM YYYY')
          }
        },
        {
          key: 'actions',
          label: 'Action',
          sortable: true
        }
      ],
      fieldsEmptyActivity: [
        {
          key: 'name',
          label: 'Leads Name',
          sortable: true
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true
        },
        {
          key: 'phone_number',
          label: 'Phone',
          sortable: true
        },
        {
          key: 'leads_source',
          label: 'Lead Source',
          sortable: true
        },
        {
          key: 'advisor_name',
          label: 'Advisor',
          sortable: true
        },
        {
          key: 'created_at',
          label: 'Lead Created Date',
          sortable: true,
          formatter: value => {
            return moment(value).format('DD MMMM YYYY')
          }
        },
        {
          key: 'actions',
          label: 'Action',
          sortable: true
        }
      ],
      fields_sales: [
        {
          key: 'name',
          label: 'Leads Name',
          sortable: true
        },
        {
          key: 'phone_number',
          label: 'Phone Number',
          sortable: true
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true
        },
        'actions'
      ],
      fields_idle: [
        'id',
        {
          key: 'branch.name',
          label: 'Club',
          sortable: true
        },
        {
          key: 'name',
          label: 'Fullname',
          sortable: true
        },
        {
          key: 'phone_number',
          label: 'Phone Number',
          sortable: true
        },
        {
          key: 'membership.name',
          label: 'Membership Type',
          sortable: true
        },
        {
          key: 'membership_status.name',
          label: 'Membership Status',
          sortable: true
        },
        {
          key: 'advisor',
          label: 'Advisor',
          sortable: true
        },
        {
          key: 'last_gym_attendance',
          label: 'Last Check In',
          sortable: true
        },
        {
          key: 'last_activity_at',
          label: 'Last update (Actv)',
          sortable: true
        },
        {
          key: 'last_activity_by',
          label: 'Update by',
          sortable: true
        },
        'actions'
      ],
      fields_need_to_do: [
        {
          key: 'name',
          label: 'Nama',
          sortable: false
        },
        {
          key: 'phone_number',
          label: 'Phone Number',
          sortable: false
        },
        {
          key: 'sales_owner',
          label: 'Nama MA',
          sortable: false
        },
        {
          key: 'leads_activities_type',
          label: 'Aktifitas',
          sortable: false
        },
        {
          key: 'leads_activities_status',
          label: 'Status',
          sortable: false
        },
        {
          key: 'appointment_status',
          label: 'Appointment Status',
          sortable: false
        },
        {
          key: 'next_schedule_call_date',
          label: 'Next Schedule Call Date',
          sortable: false
        },
        {
          key: 'next_schedule_call_time',
          label: 'Next Schedule Call Time',
          sortable: false
        },
        {
          key: 'notes',
          label: 'Status',
          sortable: false
        },
        {
          key: 'created_at',
          label: 'Create Date',
          sortable: false
        },
        {
          key: 'updated_at',
          label: 'Modify Date',
          sortable: false
        },
        'actions'
      ],
      listSales: [],
      listSalesMemberNotCheckIn2Weeks: [],
      listSalesEmptyActivity: [],
      listSalesMemberJoin: [],
      selectedSalesIdMemberJoin: '',
      selectedSalesId: '',
      selectedSalesIdNotCheckIn2Weeks: '',
      selectedSalesIdEmptyActivity: '',
      current_sales_id: '',
      dateWeek: '',
      items: [],
      itemsEmptyLeads: [],
      itemsLeads: [],
      itemsIdles: [],
      itemMemberNotCheckIn2Weeks: [],
      dailyItemsLeads: [],
      dailyItemsLeadsNeedToDo: [],
      loadingNeedToDo: false,
      dailyItemsPersonal_trainer: [],
      selectedDailyLeads: moment().format('YYYY-MM-DD'),
      selectedMonthlyLeads: moment().format('YYYY-MM'),
      weeklyItemsLeads: [],
      monthlyItemsLeads: [],
      dataBranch: [],
      isLoadingIdles: false,
      isLoadingNotCheckInTwoWeeks: false,
      isLoadingEmptyActivity: false,
      isLoadingMemberJoin: false,
      isLoadingMemberNotContinue: false,
      itemMemberNotContinue: [],
      currentPageMemberNotContinue: 1,
      totalPageMemberNotContinue: 0,
      fields_member_not_continue: [
        { key: 'club', label: 'Club', sortable: true },
        { key: 'member_code', label: 'Member Code', sortable: true },
        { key: 'member_name', label: 'Member Name', sortable: true },
        { key: 'phone_number', label: 'Phone Number', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'membership', label: 'Membership', sortable: true },
        { key: 'ma', label: 'MA', sortable: true },
        { key: 'personal_trainer', label: 'Personal Trainer', sortable: true },
        { key: 'expired_at', label: 'Expired At', sortable: true }
      ],

      currentRoleId: '',
      calendar1: {
        value: [2018, 11, 16],
        weeks: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        events: {},
        select(value) {
          console.log(value.toString());
        }
      },
      calendar2: {
        value: [new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate()],
        weeks: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        events: {},
        select(value) {
          let split = value.toString().split(',')
          let join = split.join('-')
          this.selectedDailyLeads = join
          // this.tesData()
        }
      },
      member_join: {
        items: [],
        table_fields: [
          {
            key: 'id',
            label: 'Member ID',
            formatter: (value, key, item) => {
              return item == null ? '-' : item.branch.codename + '-' + item.id
            },
            sortable: false
          },
          {
            key: 'name',
            label: 'Member Name',
            formatter: (value, key, item) => {
              return item.first_name + ' ' + item.last_name
            },
            sortable: false
          },
          {
            key: 'lead.sale.fullname',
            label: 'Membership Advisior',
            sortable: false
          },
          {
            key: 'membership_last_buy_name',
            label: 'Type Membership',
            sortable: false
          },
          {
            key: 'created_at',
            label: 'Join Date',
            formatter: (value, key, item) => {
              return moment(item.created_at).format('DD MMMM YYYY')
            },
            sortable: false
          },
          {
            key: 'start_membership',
            label: 'Effective Date',
            formatter: (value, key, item) => {
              return item.start_membership ? moment(item.start_membership).format('DD MMMM YYYY') : '-'
            },
            sortable: false
          },
          {
            key: 'leads_activities_status.name',
            label: 'Status',
            formatter: (value, key, item) => {
              return this.dateRangeNaming(item.start_membership)
            },
            sortable: false
          },
          {
            key: 'due_date',
            label: 'Tanggal dan jam Follow up call',
            formatter: (value, key, item) => {
              return item.lead != null ? item.lead.leads_activity == null ? '-' : moment(item.lead.leads_activity.due_date).format('DD MMMM YYYY') + '-' + item.lead.leads_activity.start_time : '-'
            },
            sortable: false
          },
          'actions'
        ],
        datesValue: (moment().startOf('month').format('YYYY-MM-DD')) + ' to ' + (moment().endOf('month').format('YYYY-MM-DD')),
        datesConfig: {
          mode: "range",
          dateFormat: "Y-m-d",
          altInput: true,
          altFormat: "d/m/y",
          defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))]
        },
        searchData: '',
        currentPage: 1,
        totalPage: 0,
      },
      dataNB: {},
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      currentPageEmptyActivity: 1,
      currentPageIdle: 1,
      currentPageNotCheckIn2Weeks: 1,
      currentPageNeedToDo: 1,
      needToDoFilterBySales: false,
      // satu filter branch untuk semua section dashboard
      branch_id: null,
      paginationLimit: 10,
      totalPage: 0,
      totalPageEmptyActivity: 0,
      totalPageIdle: 0,
      totalPageNotCheckIn2Weeks: 0,
      totalPageNeedToDo: 0,
      date_filter: '',
      role: Auth.Session.get().paradigm_role,
      clickedDate: this.parseDateTime4(),
      exportDates: (moment().format('YYYY-MM-DD')),
      needTodoDates: (moment().startOf('month').format('YYYY-MM-DD')) + ' to ' + (moment().endOf('month').format('YYYY-MM-DD')),
      needTodoDatesConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))]
      },
      needToDoSearchData: '',
      exportConfig: {
        // mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d-M-Y",
        defaultDate: [(moment().format('YYYY-MM-DD'))],
        onChange: this.onChange
      },
      attrs: [
        {
          key: "today",
          highlight: {
            backgroundColor: "#ff8080",
            // Other properties are available too, like `height` & `borderRadius`\
            contentStyle: {
              color: "#fafafa",
            },
          },
          dates: new Date()
        },
        {
          dot: "red",
          dates: []
        }
      ],
    }
  },
  computed: {
    // Filter branch tunggal tampil untuk role yang punya section berbasis branch di dashboard
    showBranchFilter() {
      return [3, 4, 6, 8, 17, 18, 20, 22, 34, 35].includes(parseInt(this.role))
    },
    checkDateToday: function () {
      var arr = []
      // dateName.setDate(dateName.getDate() + 2)
      for (var i = 0; i < 7; i++) {
        var currentDate = new Date()
        var todayNumber = moment().isoWeekday()
        var cutDay = (todayNumber - 1)
        currentDate.setDate(currentDate.getDate() - cutDay)
        var dateName = currentDate
        dateName.setDate(dateName.getDate() + i)
        arr.push(dateName)
      }
      return arr
    }
  },
  methods: {
    exportReportNotCheckInTwoWeek() {
      this.loadingActive = true
      let url = 'fitness/v1/export/absent_in_two_week?sales_id=' + Auth.Session.get().paradigm_id + '&user_id=' + Auth.Session.get().paradigm_user_id + '&page=' + this.currentPageNotCheckIn2Weeks + '&limit=' + this.paginationLimit + '&branch_id=' + this.branch_id + '&advisor=' + this.selectedSalesIdNotCheckIn2Weeks

      // if (this.branch_id != null) {
      //   url += '&branch_id=' + this.branch_id
      // }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Report Absent In 2 Weeks ' + moment(this.exportDates).format('DD MMM YYYY') + '.xlsx'
        link.click()
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    exportEmptyActivity() {
      this.loadingActive = true
      let url = 'crm/v1/export/leads/empty_activity?sales_id=' + Auth.Session.get().paradigm_id + '&user_id=' + Auth.Session.get().paradigm_user_id + '&branch_id=' + this.branch_id
      if (this.selectedSalesIdEmptyActivity) {
        url += '&owner_id=' + this.selectedSalesIdEmptyActivity
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Leads Empty Activity ' + moment().format('DD MMM YYYY') + '.xlsx'
        link.click()
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    exportMemberJoin() {
      this.loadingActive = true
      let range_date = this.member_join.datesValue.split(' to ')
      let url = 'crm/v1/export/leads_activities/member_join?start_date=' + range_date[0] + '&end_date=' + range_date[1] + '&sales_id=' + Auth.Session.get().paradigm_id + '&user_id=' + Auth.Session.get().paradigm_user_id
      if (this.selectedSalesIdMemberJoin) {
        url += '&owner_id=' + this.selectedSalesIdMemberJoin
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Member Join ' + moment(range_date[0]).format('DD MMM YYYY') + ' - ' + moment(range_date[1]).format('DD MMM YYYY') + '.xlsx'
        link.click()
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    exportNeedToDo() {
      this.loadingActive = true

      let range_date = this.needTodoDates.split(' to ')
      let url = 'crm/v1/export/report/need_to_do?page=&limit=&is_filter_by_sales=' + this.needToDoFilterBySales + '&sales_id=' + this.selectedSalesId + '&start_date=' + range_date[0] + '&end_date=' + range_date[1] + '&date=' + this.selectedDailyLeads + '&user_id=' + Auth.Session.get().paradigm_user_id + '&username=' + Auth.Session.get().paradigm_username + '&page=' + this.currentPageNeedToDo + '&limit=' + this.paginationLimit + '&keyword=' + this.needToDoSearchData

      if (this.branch_id) {
        url += '&branch_id=' + this.branch_id
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Need To Do Report ' + moment(this.needToDoDates).format('DD MMM YYYY') + '.xlsx'
        link.click()
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    dateRangeNaming(date) {
      var past = moment(`${date}`)
      var now = moment()
      var numYears, numMonths, numDays;
      numMonths = now.diff(past, 'months');
      past = past.add(numMonths, 'months');
      numDays = now.diff(past, 'days');
      numYears = now.diff(past, 'years');

      if (numYears == 0 && numMonths == 0) {
        if (numDays == 0) {
          var hasil = '1 Days After Join'
        } else {
          var hasil = numDays + ' Days After Join'
        }
      } else if (numYears == 0 && numMonths != 0) {
        if (numDays == 0) {
          var hasil = numMonths + ' Month'
        } else {
          var hasil = numMonths + ' Month, ' + numDays + ' Days'
        }
      } else if (numYears != 0) {
        if (numMonths == 0 && numDays == 0) {
          var hasil = numYears + ' Tahun';
        } else if (numMonths != 0 && numDays == 0) {
          var hasil = numMonths + ' Month'
        } else if (numMonths == 0 && numDays != 0) {
          var hasil = numDays + ' Days After Join'
        } else if (numMonths != 0 && numDays != 0) {
          var hasil = numMonths + ' Month, ' + numDays + ' Days'
        }
      }
      return hasil
    },
    changeDateBooking(selectedDates, dateStr, instance) {
      if (selectedDates.length === 2) {
        if (typeof selectedDates[0] === typeof selectedDates[1]) {
          this.needTodoDates = dateStr + ' to ' + dateStr
          this.member_join.datesValue = dateStr + ' to ' + dateStr
        } else {
          this.needTodoDates = dateStr
          this.member_join.datesValue = dateStr
        }
        if (this.needTodoDates.includes(" to ") === true) {
          this.getSalesLeadsActivity(this.exportDates)
        }
        if (this.member_join.datesValue.includes(" to ") === true) {
          this.getMemberJoin()
        }
      }
    },
    changeActivity(event) {
      this.leads_activities_type_id = event
      console.log(event)
      this.fetchData()
    },
    needToDoChangeSales(event) {
      this.selectedSalesId = event
      if (this.selectedSalesId) {
        this.needToDoFilterBySales = true
      }
      this.getSalesLeadsActivity(this.selectedDailyLeads)
    },
    notCheckIn2WeeksSalesChanged(event) {
      this.selectedSalesIdNotCheckIn2Weeks = event
      this.getNotCheckInMember2Weeks()
    },
    detailActivity(event) {
      this.$router.push(event)
    },
    changeRangeDate(event) {
      let date = moment(new Date(event)).format('YYYY-MM-DD')
      axios.get('crm/v1/leads_activities/daily_calendar?sales_id=' + Auth.Session.get().paradigm_id + '&date=' + date + '&user_id' + Auth.Session.get().paradigm_user_id + `&branch_id=${this.branch_id}`).then(response => {
        this.dailyItemsLeads = response.data.data.rows
        this.dailyItemsLeadsNeedToDo = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    changeDateNeedToDo(selectedDates, dateStr, instance) {
      if (selectedDates.length === 2) {
        if (typeof selectedDates[0] === typeof selectedDates[1]) {
          this.needTodoDates = dateStr + ' to ' + dateStr
          this.member_join.datesValue = dateStr + ' to ' + dateStr
        } else {
          this.needTodoDates = dateStr
          this.member_join.datesValue = dateStr
        }

        if (this.needTodoDates.includes(" to ") === true) {
          this.loadingNeedToDo = true
          // need to do
          let range_date = this.needTodoDates.split(' to ')
          let setUrl = 'crm/v1/leads_activities/need_to_do?is_filter_by_sales=' + this.needToDoFilterBySales + '&sales_id=' + this.selectedSalesId + '&start_date=' + range_date[0] + '&end_date=' + range_date[1] + '&date=' + this.selectedDailyLeads + '&user_id=' + Auth.Session.get().paradigm_user_id + '&username=' + Auth.Session.get().paradigm_username + '&page=' + this.currentPageNeedToDo + '&limit=' + this.paginationLimit + '&keyword=' + this.needToDoSearchData

          if (this.branch_id) {
            setUrl += '&branch_id=' + this.branch_id
          }

          axios.get(setUrl).then(response => {
            this.loadingNeedToDo = false
            this.dailyItemsLeadsNeedToDo = response.data.data.rows
            this.totalPageNeedToDo = response.data.meta.pageCount
          }).catch(error => {
            this.loadingNeedToDo = false
            console.log('error', error)
          })
        }
      }
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    pageOneChangedEmptyActivity(pageNum) {
      this.currentPageEmptyActivity = pageNum
      this.getEmptyActivity()
    },
    pageOneIdleChanged(pageNum) {
      this.currentPageIdle = pageNum
      this.fetchData()
    },
    pageOneNotCheckIn2WeeksChanged(pageNum) {
      this.currentPageNotCheckIn2Weeks = pageNum
      this.getNotCheckInMember2Weeks()
    },
    pageOneMemberNotContinueChanged(pageNum) {
      this.currentPageMemberNotContinue = pageNum
      this.getMemberNotContinue()
    },
    getMemberNotContinue() {
      this.isLoadingMemberNotContinue = true
      let url = 'crm/v1/sales_report/member_not_continue?page=' + this.currentPageMemberNotContinue + '&limit=' + this.paginationLimit
      if (this.branch_id) {
        url += '&branch_id=' + this.branch_id
      }
      axios.get(url).then(response => {
        this.itemMemberNotContinue = response.data.data.rows
        this.totalPageMemberNotContinue = response.data.meta.pageCount
        this.isLoadingMemberNotContinue = false
      }).catch(error => {
        console.log('error', error)
        this.isLoadingMemberNotContinue = false
      })
    },
    exportMemberNotContinue() {
      this.loadingActive = true
      let url = 'crm/v1/export/member_not_continue'
      if (this.branch_id) {
        url += '?branch_id=' + this.branch_id
      }
      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Member Not Continue PT ' + moment().format('DD MMM YYYY') + '.xlsx'
        link.click()
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    pageOneNeedToDoChanged(pageNum) {
      this.currentPageNeedToDo = pageNum

      this.loadingNeedToDo = true
      // need to do
      let range_date = this.needTodoDates.split(' to ')
      let setUrl = 'crm/v1/leads_activities/need_to_do?is_filter_by_sales=' + this.needToDoFilterBySales + '&sales_id=' + this.selectedSalesId + '&start_date=' + range_date[0] + '&end_date=' + range_date[1] + '&date=' + this.selectedDailyLeads + '&user_id=' + Auth.Session.get().paradigm_user_id + '&username=' + Auth.Session.get().paradigm_username + '&page=' + this.currentPageNeedToDo + '&limit=' + this.paginationLimit + '&keyword=' + this.needToDoSearchData

      if (this.branch_id) {
        setUrl += '&branch_id=' + this.branch_id
      }

      axios.get(setUrl).then(response => {
        this.loadingNeedToDo = false
        this.dailyItemsLeadsNeedToDo = response.data.data.rows
        this.totalPageNeedToDo = response.data.meta.pageCount
      }).catch(error => {
        this.loadingNeedToDo = false
        console.log('error', error)
      })
    },
    pageOneMemberJoinChanged(pageNum) {
      this.member_join.currentPage = pageNum
      this.getMemberJoin()
    },
    sortingChanged(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    openPage(event) {
      this.$router.push(event)
    },
    toLeadsDetail(idLeads) {
      this.$router.push({ name: 'Detail Lead', params: idLeads })
    },
    toMemberDetail(idMember) {
      this.$router.push({ name: 'Detail Member', params: idMember })
    },
    enterClicked(searchEvent) {
      this.fetchData()
    },
    needToDoEnterClicked(searchEvent) {
      this.getSalesLeadsActivity(this.exportDates)
    },
    getRowCount(items) {
      return items.length
    },
    getBadge(status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'danger'
    },
    statusMembership(status) {
      return (status === 'Membership') ? 'success'
        : (status === 'On Progress') ? 'danger' : 'danger'
    },
    todayNumber() {
      return moment().isoWeekday()
    },
    cutTime(value) {
      return (value).slice(0, -3)
    },
    getNumberDay(value) {
      return moment(new Date(value)).isoWeekday()
    },
    getTodayDate(value) {
      return moment(new Date(value)).format('DD MM YY')
    },
    parseDateTime1(value) {
      moment.locale('en')
      return moment(new Date(value)).format('DD')
    },
    parseDateTime2(value) {
      moment.locale('en')
      return moment(new Date(value)).format('dddd')
    },
    parseDateTime3(value) {
      var curr = new Date
      var first = curr.getDate() - curr.getDay()
      var monthName = new Date(curr.getTime())
      moment.locale('en')
      return moment(new Date(monthName)).format('MMMM YYYY')
    },
    parseDateTime4(value) {
      var curr = new Date
      var first = curr.getDate() - curr.getDay()
      var monthName = new Date(curr.getTime())
      moment.locale('en')
      return moment(new Date(monthName)).format('MMMM YYYY')
    },
    parseImg(value) {
      return Auth.apiUrl + 'compro/v1/img/banner/' + value
    },
    text_truncate(str, length, ending) {
      if (length == null) {
        length = 100;
      }
      if (ending == null) {
        ending = '..';
      }
      if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
      } else {
        return str;
      }
    },
    getLeadActivities(value) {
      return value.leads_activity_type_id === 4
    },
    getIdleMember() {
      this.isLoadingIdles = true
      var url = 'fitness/v1/member/idle_member?sales_id=' + Auth.Session.get().paradigm_id + '&user_id=' + Auth.Session.get().paradigm_user_id + '&page=' + this.currentPageIdle + '&limit=' + this.paginationLimit + '&branch_id=' + this.branch_id

      console.log(this.branch_id)

      axios.get(url).then(response => {
        this.isLoadingIdles = false
        this.itemsIdles = response.data.data.rows
        this.totalPageIdle = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
        this.isLoadingIdles = false
      })
    },
    getNotCheckInMember2Weeks() {
      this.isLoadingNotCheckInTwoWeeks = true
      var url = 'fitness/v1/member/absent_in_two_week?sales_id=' + Auth.Session.get().paradigm_id + '&user_id=' + Auth.Session.get().paradigm_user_id + '&page=' + this.currentPageNotCheckIn2Weeks + '&limit=' + this.paginationLimit + '&branch_id=' + this.branch_id + '&advisor=' + this.selectedSalesIdNotCheckIn2Weeks

      axios.get(url).then(response => {
        this.isLoadingNotCheckInTwoWeeks = false
        this.itemMemberNotCheckIn2Weeks = response.data.data.rows
        this.totalPageNotCheckIn2Weeks = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
        this.isLoadingNotCheckInTwoWeeks = false
      })
    },
    getEmptyActivity() {
      this.isLoadingEmptyActivity = true
      let url = 'crm/v1/leads/empty_activity?sales_id=' + Auth.Session.get().paradigm_id + '&user_id=' + Auth.Session.get().paradigm_user_id + '&page=' + this.currentPageEmptyActivity + '&limit=' + this.paginationLimit + '&branch_id=' + this.branch_id
      if (this.selectedSalesIdEmptyActivity) {
        url += '&owner_id=' + this.selectedSalesIdEmptyActivity
      }
      axios.get(url).then(response => {
        this.itemsEmptyLeads = response.data.data.rows
        this.totalPageEmptyActivity = response.data.meta.pageCount
        this.isLoadingEmptyActivity = false
      }).catch(error => {
        console.log('error', error)
        this.isLoadingEmptyActivity = false
      })
    },
    // Daftar sales per branch untuk filter Sales di Leads - Empty Activity & Member Join
    getSalesList() {
      axios.get('crm/v1/sales/crm/sales_back_to_basic/sales_list?branch_id=' + this.branch_id).then(response => {
        this.listSalesEmptyActivity = response.data.data
        this.listSalesMemberJoin = response.data.data
      }).catch(error => {
        console.log('error', error)
      })
    },
    changeSalesEmptyActivity() {
      this.getEmptyActivity()
    },
    changeSalesMemberJoin() {
      this.member_join.currentPage = 1
      this.getMemberJoin()
    },
    getBranch() {
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows.filter(
          (item) => item.id == Auth.Session.get().paradigm_branch_id
        )

        // if (Auth.Session.get().paradigm_id == 15102000) {
        //   // this.branch_id = Auth.Session.get().paradigm_branch_id
        //   this.branch_id = Auth.Session.get().paradigm_branch_id
        //   this.dataBranch = this.dataBranch.filter(
        //     (item) => item.id == Auth.Session.get().paradigm_branch_id
        //   )
        // }
      }).catch(error => {
        console.log('error', error)
      })
    },
    // Filter branch tunggal: semua section dashboard dimuat ulang mengikuti branch terpilih.
    changeBranch() {
      const role = parseInt(this.role)

      // sales yang dipilih di section lain milik branch sebelumnya
      if (role !== 3) {
        this.selectedSalesId = ''
        this.needToDoFilterBySales = false
      }
      this.selectedSalesIdNotCheckIn2Weeks = ''
      this.selectedSalesIdEmptyActivity = ''
      this.selectedSalesIdMemberJoin = ''
      this.currentPageNotCheckIn2Weeks = 1
      this.currentPageEmptyActivity = 1
      this.currentPageNeedToDo = 1
      this.currentPageMemberNotContinue = 1
      this.member_join.currentPage = 1

      if ([3, 4, 6, 8, 17, 18, 20, 22].includes(role)) {
        this.getSalesLeadsActivity(this.selectedDailyLeads)
        this.getPersonalTrainerActivity(this.selectedDailyLeads)
      }
      if ([3, 4, 17, 20, 34, 35].includes(role)) {
        this.getNotCheckInMember2Weeks()
        this.loadSalesNotCheckIn2Weeks()
        this.getMemberNotContinue()
      }
      if ([3, 4, 17, 20].includes(role)) {
        this.getEmptyActivity()
        this.getMemberJoin()
      }
      if ([4, 17, 20].includes(role)) {
        this.getSalesList()
      }
      if ([4, 17].includes(role)) {
        this.loadSalesNeedToDo()
      }
    },
    loadSalesNeedToDo() {
      axios.get(`crm/v1/sales/crm/sales_back_to_basic/sales_list?branch_id=${this.branch_id}`).then(response => {
        this.listSales = response.data.data
      }).catch(error => {
        console.log('error', error)
      })
    },
    loadSalesNotCheckIn2Weeks() {
      let salesListNotCheckInUrl = 'crm/v1/sales/crm/sales_back_to_basic/sales_list'
      if (this.branch_id) {
        salesListNotCheckInUrl += '?branch_id=' + this.branch_id
      }

      axios.get(salesListNotCheckInUrl).then(response => {
        this.listSalesMemberNotCheckIn2Weeks = response.data.data
      }).catch(error => {
        console.log('error', error)
      })
    },
    getSalesLeadsActivity(date) {
      this.selectedDailyLeads = date
      this.dailyItemsLeads = []
      let branch = this.branch_id == null || this.branch_id == undefined ? '' : this.branch_id
      let leads_activity_type_id = this.leads_activities_type_id == null ? "" : this.leads_activities_type_id
      axios.get('crm/v1/leads_activities/daily_calendar?leads_activity_type_id=' + leads_activity_type_id + '&sales_id=' + Auth.Session.get().paradigm_id + '&date=' + this.selectedDailyLeads + '&user_id=' + Auth.Session.get().paradigm_user_id + '&username=' + Auth.Session.get().paradigm_username + '&branch_id=' + branch).then(response => {
        this.dailyItemsLeads = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      // need to do
      let range_date = this.needTodoDates.split(' to ')
      let setUrl = 'crm/v1/leads_activities/need_to_do?is_filter_by_sales=' + this.needToDoFilterBySales + '&sales_id=' + this.selectedSalesId + '&start_date=' + range_date[0] + '&end_date=' + range_date[1] + '&date=' + this.selectedDailyLeads + '&user_id=' + Auth.Session.get().paradigm_user_id + '&username=' + Auth.Session.get().paradigm_username + '&page=' + this.currentPageNeedToDo + '&limit=' + this.paginationLimit + '&keyword=' + this.needToDoSearchData

      if (this.branch_id) {
        setUrl += '&branch_id=' + this.branch_id
      }

      axios.get(setUrl).then(response => {
        this.dailyItemsLeadsNeedToDo = response.data.data.rows
        this.totalPageNeedToDo = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    },
    getPersonalTrainerActivity(date) {
      this.selectedDailyLeads = date
      this.dailyItemsPersonal_trainer = []
      let branch = this.branch_id == null || this.branch_id == undefined ? '' : this.branch_id
      axios.get('crm/v1/leads_activities/daily_calendar_pt?sales_id=' + Auth.Session.get().paradigm_id + '&date=' + this.selectedDailyLeads + '&user_id=' + Auth.Session.get().paradigm_user_id + '&username=' + Auth.Session.get().paradigm_username + '&branch_id=' + branch).then(response => {
        this.dailyItemsPersonal_trainer = response.data.data.rows
        // console.log('PT Activity', response)
      }).catch(error => {
        console.log('error', error)
      })
    },
    getSalesMonthlyActivity(date = this.selectedMonthlyLeads) {
      this.selectedMonthlyLeads = date
      this.monthlyItemsLeads = []
      axios.get('crm/v1/leads_activities/monthly_calendar_dots?sales_id=' + Auth.Session.get().paradigm_id + '&date=' + this.selectedMonthlyLeads + '&user_id=' + Auth.Session.get().paradigm_user_id + '&username=' + Auth.Session.get().paradigm_username).then(response => {
        let attrs = this.attrs.slice(0)
        response.data.data.forEach(element => {
          attrs[1].dates.push(new Date(element))
        });
        this.attrs = attrs;
      }).catch(error => {
        console.log('error', error)
      })
    },
    getSelectedDate(day) {
      this.getSalesLeadsActivity(moment(day.date).format('YYYY-MM-DD'))
      this.getPersonalTrainerActivity(moment(day.date).format('YYYY-MM-DD'))
    },
    getSelectedPage(page) {
      let month = moment(page.year + '-' + page.month).format('YYYY-MM')
      this.getSalesMonthlyActivity(month)
    },
    getMemberJoin() {
      // member join
      this.isLoadingMemberJoin = true
      let range_date = this.member_join.datesValue.split(' to ')

      let Url = 'crm/v1/leads_activities/member_join?start_date=' + range_date[0] + '&end_date=' + range_date[1] + '&leads_activity_type_id=&sales_id=' + Auth.Session.get().paradigm_id + '&date=' + this.selectedDailyLeads + '&user_id=' + Auth.Session.get().paradigm_user_id + '&username=' + Auth.Session.get().paradigm_username + '&page=' + this.member_join.currentPage + '&limit=' + this.paginationLimit + '&keyword=' + this.needToDoSearchData

      if (this.branch_id) {
        Url += '&branch_id=' + this.branch_id
      }
      if (this.selectedSalesIdMemberJoin) {
        Url += '&owner_id=' + this.selectedSalesIdMemberJoin
      }
      axios.get(Url).then(response => {
        this.member_join.items = response.data.data.rows
        this.member_join.totalPage = response.data.meta.pageCount
        this.isLoadingMemberJoin = false
        console.log(response.data.data.rows)
      }).catch(error => {
        this.isLoadingMemberJoin = false
        console.log('error', error)
      })
    },
    alertDefaultPass() {
      if (localStorage.getItem('is_default_pass') == 'true') {
        this.$swal({
          title: 'Information',
          text: 'You have an default password. Please change it to your new password.',
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Continue',
          showCloseButton: false,
          showLoaderOnConfirm: false
        }).then((confirm) => {
          if (confirm.value) {
            console.log('change pass')
          }
        })
      }
    },
    fetchData() {

      if (Auth.Session.get().paradigm_role === '4' || Auth.Session.get().paradigm_role === '17') {
        this.loadSalesNeedToDo()
      }
      axios.get('crm/v1/leads_activities_type/').then(response => {
        this.leads_activities_type = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      this.currentRoleId = Auth.Session.get().paradigm_role

      if (Auth.Session.get().paradigm_role == '17' || Auth.Session.get().paradigm_role == 17) {
        this.getSalesLeadsActivity(this.selectedDailyLeads)
        this.getMemberJoin()
      }
      if (Auth.Session.get().paradigm_role === '35' || Auth.Session.get().paradigm_role === '34') {
        this.getIdleMember()
        this.getNotCheckInMember2Weeks()
        this.getMemberNotContinue()
      }
      // sales manager agung 1071806
      if (Auth.Session.get().paradigm_role === '6' || Auth.Session.get().paradigm_role === '13' || Auth.Session.get().paradigm_role === '17' || Auth.Session.get().paradigm_role === '19' || Auth.Session.get().paradigm_role === '20') {
        console.log('Load data')
        // this.loadingActive = true
        this.getEmptyActivity()

        axios.get('crm/v1/leads_activities/weekly_calendar?sales_id=1071806').then(response => {
          var dataFilter = response.data.data.rows
          this.itemsLeads = dataFilter.filter(this.getLeadActivities)
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/leads_activities/monthly_calendar?sales_id=1071806').then(response => {
          var dataFilter = response.data.data.rows
          this.itemsLeads = dataFilter.filter(this.getLeadActivities)
          let obj = {}
          for (var i = 0; i < this.itemsLeads.length; i++) {
            let datum = moment(new Date(this.itemsLeads[i].due_date)).format('YYYY-M-D').toString()
            obj[datum] = this.text_truncate(this.itemsLeads[i].leads_activities_type.name, 9)
          }
          this.calendar1.events = Object.assign({}, this.calendar1.events, obj)
        }).catch(error => {
          console.log('error', error)
        })
        var curr = new Date
        var first = curr.getDate() - curr.getDay()
        var monthName = new Date(curr.getTime())
        this.calendar1.value = [moment(new Date(monthName)).format('YYYY'), moment(new Date(monthName)).format('MM'), moment(new Date(monthName)).format('DD')]

        axios.get('crm/v1/leads/my_leads/1071806' + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + '&branch_id=' + this.branch_id).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          // this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
          // this.loadingActive = false
        })
        if (Auth.Session.get().paradigm_role === '4' || Auth.Session.get().paradigm_role === '17') {
          this.getIdleMember()
          this.getNotCheckInMember2Weeks()
          this.getMemberNotContinue()
        }
      } else if (Auth.Session.get().paradigm_role === '3' || Auth.Session.get().paradigm_role === '4' || Auth.Session.get().paradigm_role === '17' || Auth.Session.get().paradigm_role === 17) {
        this.getIdleMember()
        this.getNotCheckInMember2Weeks()
        this.getMemberNotContinue()
        this.getEmptyActivity()
        this.getSalesLeadsActivity(this.selectedDailyLeads)
        this.getSalesMonthlyActivity(this.selectedMonthlyLeads)
        this.getMemberJoin()
      }
      else {
        // this.loadingActive = true
        axios.get('crm/v1/leads_activities/weekly_calendar?sales_id=' + Auth.Session.get().paradigm_id).then(response => {
          if (Auth.Session.get().paradigm_role === '4') {
            var dataFilter = response.data.data.rows
            this.itemsLeads = dataFilter.filter(this.getLeadActivities)
          } else {
            this.itemsLeads = response.data.data.rows
          }
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/leads_activities/monthly_calendar?sales_id=' + Auth.Session.get().paradigm_id).then(response => {
          if (Auth.Session.get().paradigm_role === '4') {
            var dataFilter = response.data.data.rows
            this.itemsLeads = dataFilter.filter(this.getLeadActivities)
          } else {
            this.itemsLeads = response.data.data.rows
          }
          let obj = {}
          for (var i = 0; i < this.itemsLeads.length; i++) {
            let datum = moment(new Date(this.itemsLeads[i].due_date)).format('YYYY-M-D').toString()
            obj[datum] = this.text_truncate(this.itemsLeads[i].leads_activities_type.name, 9)
          }
          this.calendar1.events = Object.assign({}, this.calendar1.events, obj)
        }).catch(error => {
          console.log('error', error)
        })

        axios.get('crm/v1/leads/my_leads/' + Auth.Session.get().paradigm_id + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + '&branch_id=' + this.branch_id).then(response => {
          // this.loadingActive = false

          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          // console.log('test', response.data.data.rows)
        }).catch(error => {
          console.log('error', error)
          // this.loadingActive = false
        })
        var curr = new Date
        var first = curr.getDate() - curr.getDay()
        var monthName = new Date(curr.getTime())
        this.calendar1.value = [moment(new Date(monthName)).format('YYYY'), moment(new Date(monthName)).format('MM'), moment(new Date(monthName)).format('DD')]
      }

      this.loadSalesNotCheckIn2Weeks()
    }
  },
  created() {
    if (Auth.Session.get().paradigm_role == 3 || Auth.Session.get().paradigm_role == '3') {
      this.current_sales_id = Auth.Session.get().paradigm_id
      this.selectedSalesId = Auth.Session.get().paradigm_id
      this.needToDoFilterBySales = true
    }

    // if (Auth.Session.get().paradigm_id == 15102000) {
    //   this.branch_id = Auth.Session.get().paradigm_branch_id
    // }
    this.branch_id = Auth.Session.get().paradigm_branch_id

    this.fetchData()
    this.getBranch()
    if ([4, 17, 20].includes(parseInt(Auth.Session.get().paradigm_role))) {
      this.getSalesList()
    }
    this.alertDefaultPass()
    // this.fetchData2()
  },
}
</script>

<style>
/*demo*/
.flex {
  box-sizing: border-box;

  display: -webkit-box;
  -webkit-box-pack: start;
  -webkit-box-align: start;

  display: -webkit-flex;
  -webkit-justify-content: space-between;
  -webkit-align-items: top;

  display: flex;
  justify-content: space-between;
  align-items: top;
  flex-flow: row wrap
}

.flex>div {
  margin: 10px;
  padding: 20px;
  width: 25%;
  min-width: 300px;
  border: 1px solid #eee;
  border-radius: 2px;
  position: relative;
}

.flex>div>span {
  position: absolute;
  left: 0px;
  top: 0px;
  padding: 2px 10px;
  font-size: 10px;
  border-radius: 0 0 2px 0;
  background: #ea6151;
  color: #fff;
}

.flex>div>input {
  box-sizing: border-box;
  width: 100%;
  margin-top: 20px;
  border-radius: 2px;
  border: 1px solid #dedede;
  padding: 10px;
  font-size: 16px;
  background: url(data:image/svg+xml;base64,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) no-repeat 8px 10px;
  padding-left: 36px;
  color: #666;
}

/*transition*/
.fade-enter-active,
.fade-leave-active {
  transition: all .5s ease-in-out;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
  transform: translateY(-10px);

}

.calendar {
  min-width: auto !important;
}

/*下拉框*/
.calendar-dropdown {
  background: #fff;
  position: absolute;
  left: 0;
  top: 0;
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 2px;
}

.calendar-dropdown:before {
  position: absolute;
  left: 30px;
  top: -10px;
  content: "";
  border: 5px solid rgba(0, 0, 0, 0);
  border-bottom-color: #DEDEDE;
}

.calendar-dropdown:after {
  position: absolute;
  left: 30px;
  top: -9px;
  content: "";
  border: 5px solid rgba(0, 0, 0, 0);
  border-bottom-color: #fff;
}

/*弹出框*/
.calendar-dialog {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.calendar-dialog-mask {
  background: rgba(255, 255, 255, .5);
  width: 100%;
  height: 100%;
}

.calendar-dialog-body {
  background: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 2px;
}

.vc-day .vc-opacity-0 {
  opacity: 0.3;
}

.vc-day .vc-pointer-events-none {
  pointer-events: all;
}
</style>
